import { create } from 'zustand';

import { FincertParam } from '../types/fincertParam';

type FincertState = {
  FINCERT_WORK_REQUEST_PARAM?: FincertParam | undefined; // 업무 파라메터
  FINCERT_INIT_YN: boolean; // 모듈 초기화 여부
  FINCERT_WORK_REQUEST_TYPE: string | undefined; // 업무 구분
  FINCERT_SIMPLEKEY_TOKEN: string | undefined; // 간편인증 등록 토큰
  FINCERT_CLOUD_CONNECTED: boolean | undefined; // 클라우드 자동연결 여부
  // FINCERT_WORK_SUCCESS_FUNC:Function | undefined; //성공콜백
  // FINCERT_WORK_FAIL_FUNC:Function | undefined; //실패콜백
};

type Actions = {
  setFINCERT_WORK_REQUEST_PARAM: (param: FincertParam) => void;
  setFINCERT_INIT_YN: (yn: boolean) => void;
  setFINCERT_WORK_REQUEST_TYPE: (type: string) => void;
  setFINCERT_SIMPLEKEY_TOKEN: (token: string) => void;
  setFINCERT_CLOUD_CONNECTED: (yn: boolean) => void;
  // setFINCERT_WORK_SUCCESS_FUNC:(func:Function) => void;
  // setFINCERT_WORK_FAIL_FUNC:(func:Function) => void;
  clearParam: () => void;
};

const useFincertStore = create<FincertState & Actions>((set) => ({
  FINCERT_WORK_REQUEST_PARAM: undefined,
  setFINCERT_WORK_REQUEST_PARAM: (param: FincertParam) =>
    set({ FINCERT_WORK_REQUEST_PARAM: param }),

  FINCERT_INIT_YN: false,
  setFINCERT_INIT_YN: (yn: boolean) => set({ FINCERT_INIT_YN: yn }),

  FINCERT_WORK_REQUEST_TYPE: undefined,
  setFINCERT_WORK_REQUEST_TYPE: (type: string) => set({ FINCERT_WORK_REQUEST_TYPE: type }),

  FINCERT_SIMPLEKEY_TOKEN: undefined,
  setFINCERT_SIMPLEKEY_TOKEN: (token: string) => set({ FINCERT_SIMPLEKEY_TOKEN: token }),

  FINCERT_CLOUD_CONNECTED: undefined,
  setFINCERT_CLOUD_CONNECTED: (yn: boolean) => set({ FINCERT_CLOUD_CONNECTED: yn }),

  // FINCERT_WORK_SUCCESS_FUNC: undefined,
  // FINCERT_WORK_FAIL_FUNC: undefined,
  // setFINCERT_WORK_SUCCESS_FUNC:(func:Function) => set({FINCERT_WORK_SUCCESS_FUNC:func}),
  // setFINCERT_WORK_FAIL_FUNC:(func:Function) => set({FINCERT_WORK_FAIL_FUNC:func}),

  clearParam: () =>
    set({
      // 업무데이터와 업무구분만 초기화한다
      FINCERT_INIT_YN: false,
      FINCERT_WORK_REQUEST_PARAM: undefined,
      FINCERT_WORK_REQUEST_TYPE: undefined,
      FINCERT_SIMPLEKEY_TOKEN: undefined,
      FINCERT_CLOUD_CONNECTED: undefined,
    }),
}));

export default useFincertStore;
